module.exports = __webpack_public_path__ + "img/coin.3b37fc00.svg";